import { axios } from "utils";

import { ADMIN_PIGLET_URL as endpoint } from "consts";

import { PigletFeedType, PigletManureStorage } from "models";

export const getPigletFeedTypesAdmin = async ({ enabled }: { enabled?: boolean } = {}): Promise<PigletFeedType[]> =>
  axios.get(`${endpoint}/piglet-feed-types`, { params: { enabled } });

export const getPigletManureStorageAdmin = async (): Promise<PigletManureStorage[]> =>
  axios.get(`${endpoint}/piglet-manure-storage-types`, { params: { enabled: true } });
